import { ApolloClient } from '@apollo/client/core'

import { apolloClientOptions } from './apolloClientOptions'
import genericErrorLink from './genericErrorLink'
import localeLink from './localeLink'
import partnerCompanyLink from './partnerCompanyLink'
import { platformApiHttpLink } from './platformApiHttpLink'

export const platformApiApolloClient = new ApolloClient({
  ...apolloClientOptions,
  link: localeLink.concat(partnerCompanyLink).concat(genericErrorLink).concat(platformApiHttpLink),
  devtools: {
    enabled: process.env.NODE_ENV === 'development',
  },
})
